import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from './services/auth';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService implements CanActivate {

  constructor(private router: Router,
              private auth: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot): any {
    const checkResult = this.auth.isUserSignedIn();
    if (!checkResult) {
      this.router.navigate(['/login']);
      return false;
    } else {
      if (route.data['role'] !== undefined) {
        const roleCheck = route.data['role'] >= this.auth.getUser().fk_id_role;
        if (!roleCheck) {
          this.router.navigate(['/error']);
        }
        return roleCheck;
      }
    }
  }
}
